module.exports = __webpack_public_path__ + "static/media/icon-twb-logo-full.a049e7ef.svg";